import React, { memo } from 'react';
import s from './Toggle.module.scss';
import dots from './image/dots.png';

const Toggle = ({ checked, onChange, name, disable }) => {
    return (
        <label id={name} className={s.switch}>
            <input
                className={s.input}
                type="checkbox"
                onChange={onChange}
                name={name}
                checked={checked}
                disabled={disable}
            />
            <div className={s.slider}>
                <div className={s.toggle}>
                    <img src={dots} alt="" />
                </div>
            </div>
        </label>
    );
};

Toggle.defaultProps = {
    checked: false,
    onChange: () => {},
    name: '',
    disable: ''
};

export default memo(Toggle);
